"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var fromImage = function fromImage(_ref) {
  var image = _ref.image;
  return image;
};
var fromHoverImage = function fromHoverImage(_ref2) {
  var image = _ref2.image,
    hoverImage = _ref2.hoverImage;
  return hoverImage || image;
};
var fromPressedImage = function fromPressedImage(_ref3) {
  var image = _ref3.image,
    pressedImage = _ref3.pressedImage;
  return pressedImage || image;
};
var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "style__StyledButton",
  componentId: "sc-1ci7zpd-0"
})(["border:0 none;margin:0;padding:0;background:transparent url(", ");width:", ";height:", ";background-size:contain;&:focus{outline:none;}&:hover{background-image:url(", ");}&:active{background-image:url(", ");}&::after{content:\"\";background:url(", ") no-repeat -9999px -9999px;}&::before{content:\"\";background:url(", ") no-repeat -9999px -9999px;}"], fromImage, function (_ref4) {
  var width = _ref4.width;
  return "".concat(width, "px");
}, function (_ref5) {
  var height = _ref5.height;
  return "".concat(height, "px");
}, fromHoverImage, fromPressedImage, fromHoverImage, fromPressedImage);
exports.StyledButton = StyledButton;